import React, { memo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ItemTipping = memo(({ className, itemTipping, onSelected }) => {
  const { t } = useTranslation("translation");
  return (
    <div className={className}>
      <div
        onClick={onSelected}
        className={
          "px-4 py-2 variation-tab " + (itemTipping.isSelected ? "active" : "")
        }
      >
        <div className="font-700 fs-18 text-amount flex justify-center items-center">
          {"+" + itemTipping?.["amount"] / 1000 + "k"}
        </div>
      </div>
    </div>
  );
});

export default styled(ItemTipping)`
  position: relative;
  .variation-tab {
    justify-content: center;
    display: flex;
    height: 80px;
    width: auto;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid #e1e1e1;
    font-weight: 500;
    font-size: 14px;
    margin: 5px;
    line-height: 21px;
    color: #000000;
    font-family: "Manrope-Medium", sans-serif;
    &.active {
      border: 1px solid #47c751;
      border-radius: 4px;
      &::before {
        content: "";
        border-radius: 4px;
        position: absolute;
        top: 0;
        margin: 5px;
        right: 0;
        width: 0;
        height: 0;
        border-top: 20px solid #47c751;
        border-left: 20px solid transparent;
      }

      &::after {
        content: "\\2713";
        position: absolute;
        top: -4px;
        margin: 5px;
        right: 0;
        border-radius: 4px;
        color: #ffffff;
        font-size: 10px;
      }
    }
  } *
`;
